/**
 * Low-quality image placeholder (LQIP) reveal.
 *
 * A small low-resolution image (see the .lqip::before rule in CSS) paints behind the
 * real image so nothing is ever blank while it loads. This script marks the closest
 * .lqip container as "is-loaded" once its real image (.lqip-image) has finished
 * loading, which fades the placeholder out.
 *
 * Works for images that are already cached, lazy images that load on scroll, and
 * images injected later by faceting / pagination / gallery swaps.
 */
(function () {
  var TARGET = 'lqip-image';

  function markLoaded(img) {
    var box = img.closest('.lqip');
    if (box) box.classList.add('is-loaded');
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.' + TARGET).forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) markLoaded(img);
    });
  }

  // Catches load events for any current or future .lqip-image (load doesn't bubble,
  // so we listen in the capture phase at the document level).
  document.addEventListener(
    'load',
    function (event) {
      var img = event.target;
      if (img && img.classList && img.classList.contains(TARGET)) markLoaded(img);
    },
    true
  );

  // Handle already-complete images (cached) that loaded before this script ran.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sweep();
    });
  } else {
    sweep();
  }

  // Handle images inserted after load (facets, pagination, gallery swaps, etc.).
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) sweep(added[j]);
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
